import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useZeroResultsSearchPageExperiment = () => {
    const hasZeroResultsSearchPageControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.ZeroResultsSearchPage,
        AmplitudeVariants.ZeroResultsSearchPage.Control
    );

    const hasZeroResultsWithFuzzyMatch = useAmplitudeExperimentBase(
        AmplitudeExperiments.ZeroResultsSearchPage,
        AmplitudeVariants.ZeroResultsSearchPage.ZeroResultsWithFuzzyMatch
    );

    const hasZeroResultsWithNoFuzzyMatch = useAmplitudeExperimentBase(
        AmplitudeExperiments.ZeroResultsSearchPage,
        AmplitudeVariants.ZeroResultsSearchPage.ZeroResultsWithNoFuzzyMatch
    );

    return {
        hasZeroResultsSearchPageControl,
        hasZeroResultsWithFuzzyMatch,
        hasZeroResultsWithNoFuzzyMatch,
    };
};
